import { Route, Routes } from 'react-router';

import TopicsCreate from './TopicsCreate';
import TopicsEdit from './TopicsEdit';
import TopicsList from './TopicsList';

function TopicModule() {
  return (
    <Routes>
      <Route path="" element={<TopicsList />} />
      <Route path="create" element={<TopicsCreate />} />
      <Route path=":id" element={<TopicsEdit />} />
    </Routes>
  );
}

export default TopicModule;
